import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ResultsData } from "../../state/Agencies/ResultsData";
import { DEFAULT_LIMIT } from "../../state/SearchManager/FormData";

const updateResultsData: Reducer<ResultsData> = (
  state: ResultsData = new ResultsData(),
  action: Action<ActionType, ResultsData>
) => {
  let updatedItemsList = action.data,
    showMore = false;
  switch (action.type) {
    case ActionType.AGENCIES_DATA_FETCHED:
      if (updatedItemsList.length > DEFAULT_LIMIT) {
        updatedItemsList = updatedItemsList.slice(0, DEFAULT_LIMIT);
        showMore = true;
      }
      return { ...state, items: updatedItemsList, showMore };
    case ActionType.AGENCIES_DATA_UPDATED:
      if (updatedItemsList.length > DEFAULT_LIMIT) {
        updatedItemsList = updatedItemsList.slice(0, DEFAULT_LIMIT);
        showMore = true;
      }
      return {
        ...state,
        items: [...state.items, ...updatedItemsList],
        showMore,
      };
    case ActionType.AGENCIES_DATA_REFRESHED:
      if (updatedItemsList.length - 1 > state.items.length) {
        showMore = true;
      }
      return { ...state, ruleList: updatedItemsList, showMore };
    case ActionType.AGENCIES_ALL_DATA_FETCHED:
      return { ...state, allItems: updatedItemsList, showMore };
    case ActionType.AGENCIES_ALL_DATA_UPDATED:
      return { ...state, allItems: updatedItemsList, showMore };
    default:
      return state;
  }
};

export default updateResultsData;
